import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PrivacidadPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-488">
      <section className="relative py-16 md:py-20 bg-brand-navy overflow-hidden" data-id="element-489">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-royal/30 via-brand-navy to-brand-navy" data-id="element-490"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-491">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-492">
            <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-brand-gold transition-colors text-sm mb-8 group" data-id="element-493">
              <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-494" />
              Volver al inicio
            </Link>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white leading-tight" data-id="element-495">
              Política de Privacidad y{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200" data-id="element-496">
                Protección de Datos
              </span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-20" data-id="element-497">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-gray-700 leading-relaxed space-y-8" data-id="element-498">
          <div data-id="element-499">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-500">
              1. INTRODUCCIÓN
            </h2>
            <p data-id="element-501">
              En REDORG valoramos y respetamos la privacidad de nuestros
              usuarios. Esta Política de Privacidad describe cómo recopilamos,
              utilizamos, almacenamos y protegemos los datos personales que
              usted nos proporciona al utilizar nuestros sitios, APPs,
              terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>
          </div>

          <div data-id="element-502">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-503">
              2. RESPONSABLE DEL TRATAMIENTO
            </h2>
            <ul className="space-y-1 ml-1" data-id="element-504">
              <li data-id="element-505">
                <strong data-id="element-506">Nombre de la entidad:</strong> Fundación REDORG
              </li>
              <li data-id="element-507">
                <strong data-id="element-508">Dirección Legal:</strong> Edificio The Point, Oficina
                1803, Puerto Santa Ana, Guayaquil, Ecuador.
              </li>
              <li data-id="element-509">
                <strong data-id="element-510">Correo electrónico de contacto:</strong>{' '}
                protecciondatos@redorg.net
              </li>
            </ul>
          </div>

          <div data-id="element-511">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-512">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h2>
            <p className="mb-3" data-id="element-513">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-514">
              <li data-id="element-515">Nombres y apellidos</li>
              <li data-id="element-516">Número de Cédula</li>
              <li data-id="element-517">Correo electrónico</li>
              <li data-id="element-518">Número de teléfono</li>
              <li data-id="element-519">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-520">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
            </ul>
          </div>

          <div data-id="element-521">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-522">
              4. FINALIDAD DEL TRATAMIENTO
            </h2>
            <p className="mb-3" data-id="element-523">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-524">
              <li data-id="element-525">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-526">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-527">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-528">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-529">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-530">Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </div>

          <div data-id="element-531">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-532">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h2>
            <p className="mb-3" data-id="element-533">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-534">
              <li data-id="element-535">Tu consentimiento expreso</li>
              <li data-id="element-536">
                El interés legítimo de REDORG para cumplir su misión
                institucional
              </li>
              <li data-id="element-537">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>
          </div>

          <div data-id="element-538">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-539">
              6. DESTINATARIOS DE LOS DATOS
            </h2>
            <p className="mb-3" data-id="element-540">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-541">
              <li data-id="element-542">Tengamos tu consentimiento previo</li>
              <li data-id="element-543">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-544">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios) con contratos que
                garantizan la protección de tus datos
              </li>
            </ul>
          </div>

          <div data-id="element-545">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-546">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h2>
            <p className="mb-3" data-id="element-547">Tienes derecho a:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-548">
              <li data-id="element-549">Acceder a tus datos personales</li>
              <li data-id="element-550">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-551">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-552">Oponerte al tratamiento</li>
              <li data-id="element-553">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-554">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-3" data-id="element-555">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <a href="mailto:protecciondatos@redorg.net" className="text-brand-royal underline hover:text-brand-navy transition-colors" data-id="element-556">
                protecciondatos@redorg.net
              </a>
            </p>
          </div>

          <div data-id="element-557">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-558">
              8. USO DE COOKIES
            </h2>
            <p data-id="element-559">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </div>

          <div data-id="element-560">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-561">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h2>
            <p data-id="element-562">
              REDORG aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </div>

          <div data-id="element-563">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-564">
              10. CONSERVACIÓN DE LOS DATOS
            </h2>
            <p data-id="element-565">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </div>

          <div data-id="element-566">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-567">
              11. CAMBIOS A ESTA POLÍTICA
            </h2>
            <p data-id="element-568">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>
          </div>

          <div data-id="element-569">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-570">
              12. AUTORIDAD DE CONTROL
            </h2>
            <p data-id="element-571">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </div>

          <div data-id="element-572">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-573">
              13. VIGENCIA
            </h2>
            <p data-id="element-574">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 20 de marzo de 2026 y permanecerá vigente hasta que
              exista una nueva versión que la reemplace.
            </p>
          </div>
        </motion.div>
      </section>
    </div>;
}